import React, { useState, useEffect } from 'react'
import globalData from 'meinian-package/src/common/globalData'
import ForceGuidePanel from './forceGuidePanel'
import imageDetailForceGuide, { GUIDE_START_KEY } from './forceGuideConfig'

export default function Guide({ shareUrl }:{ shareUrl:string }) {
  const [forceGuideHidden, setForceGuideHidden] = useState(0)
  const [forcePositions, setForcePositions] = useState([])

  imageDetailForceGuide.useOn((position) => {
    setForcePositions(position)
  })

  useEffect(() => {
    globalData.get(GUIDE_START_KEY, setForceGuideHidden, 1)
  }, [])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {
      !!forceGuideHidden && !shareUrl && <ForceGuidePanel
        positions={forcePositions}
        onClose={() => {
          setForceGuideHidden(0)
          globalData.set(GUIDE_START_KEY, 0)
        }}
      />
    }
  </>
}
